/**
 * Copyright (C) 2021 盈宝信息科技（广州）有限公司 All Rights Reserved.
 */
import config from '@/config'

/**
 * 通用app调用配置
 * @param {*} config 调用配置
 */
const callAppMethod = config => {
  // 当不存在webview内，或者全局变量中没注册sdk则退出
  if (!WBAppSdk.inApp || !window[WBAppSdk.name]) return false

  // 注册全局回调函数
  if (config.callback && typeof config.callback === 'function') {
    const callbackName = `__native_callback_${(Math.random() * 100000000).toFixed(0)}`

    const callback = config.callback.bind(config)
    window[callbackName] = function (args) {
      callback(args)
      delete window[callbackName]
    }

    config.callback = callbackName
  }

  window[WBAppSdk.name].postMessage(JSON.stringify(config))
}

class WBAppSdk {
  static name = 'WBAppSdk'
  static inApp = navigator.userAgent.includes('winBullApp') // 是否在盈宝app内打开
  static baseUrl = config.apiUrl

  /**
   * app弹出媒体选择框
   * @param {String} fileType 文件类型[image/video]
   * @param {Number} uploadType 上传类型[1/2/3/11/12/13/20]
   * 1：大陆身份证前照，2：大陆身份证背照，3：大陆人脸视频，11：香港身份证前照，12：香港身份证背照，13：香港通讯地址，20：转账凭证
   * @param {String} api api接口
   * @param {Function|String} callback 回调函数
   */
  static openMediaSheet(fileType, uploadType, api, callback) {
    return callAppMethod({
      method: 'openMediaSheet',
      params: { fileType, uploadType, httpUrl: WBAppSdk.baseUrl + api },
      callback
    })
  }

  /**
   * app退出webview
   * @param {Function|String} callback 回调函数
   */
  static exitWebView(callback) {
    return callAppMethod({ method: 'exitWebView', callback })
  }

  /**
   * 从H5接收图片并分享
   * @param {String} img base64图片
   * @param {Function|String} callback 回调函数
   */
  static acceptImgToShare(img, callback) {
    return callAppMethod({ method: 'acceptImgToShare', params: { img: img }, callback })
  }

  /**
   * 行情会员购买
   * @param {String} id 行情会员id
   * @param {Function|String} callback 回调函数
   */
  static buyQuoteVip(id, callback) {
    return callAppMethod({ method: 'buyQuoteVip', params: { id: id }, callback })
  }

  /**
   * 打开开户活动
   */
  static accountOpenActivityHandle() {
    return callAppMethod({ method: 'accountOpenActivityHandle' })
  }

  /**
   * 打开指定url
   */
  static openWebUrl(url, callback) {
    return callAppMethod({ method: 'openWebUrl', params: { url }, callback })
  }

  /**
   * 活动分享
   */
  static activityLinkShare(params) {
    return callAppMethod({ method: 'activityLinkShare', params })
  }

  /**
   * 打开交易首页
   */
  static gotoTradeHome() {
    return callAppMethod({ method: 'gotoTradeHome' })
  }

  /**
   * 打开入金
   */
  static toCashIn() {
    return callAppMethod({ method: 'toCashIn' })
  }

  /**
   * 通用活动处理
   */
  static activityCommonHandle(id) {
    return callAppMethod({ method: 'activityCommonHandle', params: { activityId: id } })
  }

  /**
   * 获取token
   */
  static getToken(callback) {
    return callAppMethod({ method: 'getToken', callback })
  }

  /**
   * 获取app视图尺寸信息
   */
  static getAppViewSizeInfo(callback) {
    return callAppMethod({ method: 'getAppViewSizeInfo', callback })
  }

  /**
   * 打开转仓页面
   */
  static goStockTrans(callback) {
    return callAppMethod({ method: 'goStockTrans', callback })
  }

  /**
   * 调起登录
   */
  static toLogin() {
    return callAppMethod({ method: 'login' })
  }

  /**
   * 打开正股下单页
   */
  static goInStockDeal(params) {
    return callAppMethod({ method: 'goInStockDeal', params })
  }

  /**
   * 打开日内融支持股票列表
   */
  static goIntradayStockPage(params) {
    return callAppMethod({ method: 'goIntradayStockPage', params })
  }

  /**
   * 打开日内融下单
   */
  static goIntradayStockDeal(params) {
    return callAppMethod({ method: 'goIntradayStockDeal', params })
  }

  /**
   * 活动海报分享
   */
  static activityPosterShare(params) {
    return callAppMethod({ method: 'activityPosterShare', params })
  }
}

export default WBAppSdk
